import { SyncStatus, SyncStatusView } from '../../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/models'

export const unifyDocumentSyncStatuses = (
  documentSummarySyncStatuses: SyncStatus[] = [],
  contactChangesSyncStatuses: SyncStatusView[] = [],
): SyncStatusView[] => {
  return [...documentSummarySyncStatuses.map((syncStatus) => ({ ...syncStatus, type: 'documentSummary' })), ...contactChangesSyncStatuses]
}
